/* global globalThis */
import url from './apiURL';
import { authenticatedFetch } from "../../utils/authenticatedFetch";
import { getValidToken } from "../../utils/getValidToken";

/**
 * INTR Recovery Filters API call
 * @param {*} payload 
 * @returns 
 */
export const fetchINTRRecoveryFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.INTRRecoveryFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

/**
 * INTR Overview Table API call
 * @param {*} payload 
 * @returns 
 */
export const fetchINTROverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.INTROverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching INTR Overview Table data:', error);
        throw error;
    }
};


export const fetchIntrRecoveryGlobalGraph = async (payload) => {
  try {
    return await authenticatedFetch(url.INTRRecoveryGlobalGraph, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error(
      "Error fetching Intr Recovery Global Graph data:",
      error,
    );
    throw error;
  }
};

export const fetchIntrRecoveryShipmentTable = async (payload) => {
  try {
    return await authenticatedFetch(url.INTRRecoveryShipmentTable, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error(
      "Error fetching Intr Recovery Shipment Table data:",
      error,
    );
    throw error;
  }
};
export const fetchMaterialViewGraph = async (payload) => {
  try {
      return await authenticatedFetch(url.MaterialViewGraph, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error(
      "Error fetching Intr Recovery Global Graph data:",
      error,
    );
    throw error;
  }
};

export const fetchMaterialViewSummaryTable = async (payload) => {
  try {
      return await authenticatedFetch(url.MaterialViewSummaryTable, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error(
      "Error fetching Intr Recovery Shipment Table data:",
      error,
    );
    throw error;
  }
};


/**
 * INTR export API call
 * @param {*} payload 
 * @returns
 */
export const fetchINTREXPORT = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.INTRExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `INTR_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

/**
 * INTR Recovery Filters API call
 * @param {*} payload 
 * @returns 
 */
export const fetchINTRMaterialRecoveryFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.INTRMaterialRecoveryFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

/**
 * INTR Overview Table API call
 * @param {*} payload 
 * @returns 
 */
export const fetchINTRMaterialOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.INTRMaterialOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching INTR Material Overview Table data:', error);
        throw error;
    }
};

/**
 * INTR export API call
 * @param {*} payload 
 * @returns
 */
export const fetchINTRMaterialEXPORT = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.INTRMaterialExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `Material_View_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching high risk SKU data:', error);
        throw error;
    }
};

export const fetchUnloadingPriorityGlobalFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.UnloadingPriorityGlobalviewFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Unloading Priority Globalview Filters data:', error);
        throw error;
    }
};

export const fetchUnloadingPrioritizationGlobalOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.UnloadingPriorityGlobalviewOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Unloading Priority Global Overview Table data:', error);
        throw error;
    }
};

export const fetchUnloadingPriorityGlobalExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.UnloadingPriorityGlobalviewExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `Unloading Priority Global_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching Unloading Priority Global view Export data:', error);
        throw error;
    }
};
export const fetchInTransitRecoveryGlobalFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.InTransitRecoveryGlobalviewFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching In Transit Recovery Globalview Filters data:', error);
        throw error;
    }
};

export const fetchInTransitRecoveryGlobalOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.InTransitRecoveryGlobalviewOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching In Transit Recovery Global Overview Table data:', error);
        throw error;
    }
};

export const fetchInTransitRecoveryGlobalExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.InTransitRecoveryGlobalviewExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `In Transit Recovery Global_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching In Transit Recovery Global view Export data:', error);
        throw error;
    }
};
export const fetchDispatchPriorityGlobalFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.DispatchPriorityGlobalviewFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Dispatch Priority Globalview Filters data:', error);
        throw error;
    }
};

export const fetchDispatchPrioritizationGlobalOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.DispatchPriorityGlobalviewOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Dispatch Priority Global Overview Table data:', error);
        throw error;
    }
};

export const fetchDispatchPriorityGlobalExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.DispatchPriorityGlobalviewExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `Dispatch Priority Global_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching Dispatch Priority Global view Export data:', error);
        throw error;
    }
};

export const fetchUnloadingPriorityShipmentFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.UnloadingPriorityShipmentviewFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Unloading Priority Shipment view Filters data:', error);
        throw error;
    }
};

export const fetchUnloadingPrioritizationShipmentOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.UnloadingPriorityShipmentviewOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Unloading Priority Shipment Overview Table data:', error);
        throw error;
    }
};

export const fetchUnloadingPriorityShipmentExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.UnloadingPriorityShipmentviewExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `Unloading Priority Shipment_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching Unloading Priority Shipment view Export data:', error);
        throw error;
    }
};
export const fetchInTransitRecoveryShipmentFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.InTransitRecoveryShipmentviewFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching In Transit Recovery Shipment view Filters data:', error);
        throw error;
    }
};

export const fetchInTransitRecoveryShipmentOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.InTransitRecoveryShipmentviewOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching In Transit Recovery Shipment Overview Table data:', error);
        throw error;
    }
};

export const fetchInTransitRecoveryShipmentExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.InTransitRecoveryShipmentviewExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `In Transit Recovery Shipment_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching In Transit Recovery Shipment view Export data:', error);
        throw error;
    }
};

export const fetchDispatchPriorityShipmentFilters = async (payload) => {
    try {
        return await authenticatedFetch(url.DispatchPriorityShipmentviewFilters, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Dispatch Priority Shipment view Filters data:', error);
        throw error;
    }
};

export const fetchDispatchPrioritizationShipmentOverviewTable = async (payload) => {
    try {
        return await authenticatedFetch(url.DispatchPriorityShipmentviewOverviewTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Dispatch Priority Shipment Overview Table data:', error);
        throw error;
    }
};

export const fetchDispatchPriorityShipmentExport = async (payload) => {
    try {
        const token = await getValidToken();
        const response = await fetch(url.DispatchPriorityShipmentviewExport, {  
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const urll = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urll;
        link.setAttribute("download", `Dispatch Priority Shipment_${payload.uom}.xlsx`);
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(urll);
    } catch (error) {
        console.error('Error fetching Dispatch Priority Shipment view Export data:', error);
        throw error;
    }
};

export const fetchUnloadingPriorityGlobalFifoGraph = async (payload) => {
    try {
        return await authenticatedFetch(url.UnloadingPriorityGlobalFifoGraph, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Unloading Priority Global Fifo Graph data:', error);
        throw error;
    }
};

export const fetchUnloadingPriorityShipmentTable = async (payload) => {
    try {
        return await authenticatedFetch(url.UnloadingPriorityShipmentTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Unloading Priority Shipment Table data:', error);
        throw error;
    }
};

export const fetchDispatchPriorityGlobalFifoGraph = async (payload) => {
    try {
        return await authenticatedFetch(url.DispatchPriorityGlobalFifoGraph, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Dispatch Priority Global Fifo Graph data:', error);
        throw error;
    }
};

export const fetchDispatchPriorityShipmentTable = async (payload) => {
    try {
        return await authenticatedFetch(url.DispatchPriorityShipmentTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching Dispatch Priority Shipment Table data:', error);
        throw error;
    }
};

export const fetchInTransitRecoveryGlobalFifoGraph = async (payload) => {
    try {
        return await authenticatedFetch(url.InTransitRecoveryGlobalFifoGraph, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching InTransit Recovery Global Fifo Graph data:', error);
        throw error;
    }
};

export const fetchInTransitRecoveryShipmentTable = async (payload) => {
    try {
        return await authenticatedFetch(url.InTransitRecoveryShipmentTable, {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.error('Error fetching InTransit Recovery Shipment Table data:', error);
        throw error;
    }
};


